import { PropsWithChildren, useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

export default function TaggedPlace({ children }: PropsWithChildren) {
  const placeRef = window.localStorage.getItem("placeRef");
  const [search] = useSearchParams();
  useEffect(() => {}, [placeRef]);

  const searchPlaceRef = search.get("placeRef");
  if (searchPlaceRef) {
    console.log(placeRef);
    window.localStorage.setItem("placeRef", searchPlaceRef);
    window.localStorage.setItem("placeRefTimestamp", Date.now().toString());
  }

  const placeRefTimestamp = window.localStorage.getItem("placeRefTimestamp") || "0";
  const isTimestampValid =
    placeRefTimestamp && Date.now() - parseInt(placeRefTimestamp) < 30 * 60 * 1000; // 30 minutes

  if (!isTimestampValid) {
    console.log(
      "Place ref timestamp is invalid or older than 30 minutes, redirecting to /tag-place",
    );
    return <Navigate to={"/tag-place"} />;
  }

  if (!placeRef && !searchPlaceRef) {
    console.log("No place ref found, redirecting to /tag-place");
    return <Navigate to={"/tag-place"} />;
  }

  return <> {children}</>;
}
